import { render, staticRenderFns } from "./PageLimitSelect.vue?vue&type=template&id=64c946a6&"
import script from "./PageLimitSelect.vue?vue&type=script&lang=js&"
export * from "./PageLimitSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports